import React from "react";

/**
 * Embeds a YouTube/Twitch/Facebook live video.
 * Accepts a watch URL and converts to embed iframe.
 */
export default function LivestreamEmbed({ url }) {
    if (!url) return null;

    let embedUrl = url;
    try {
        const u = new URL(url);
        if (u.hostname.includes("youtube.com")) {
            const id = u.searchParams.get("v");
            if (id) embedUrl = `https://www.youtube.com/embed/${id}`;
        } else if (u.hostname.includes("youtu.be")) {
            embedUrl = `https://www.youtube.com/embed${u.pathname}`;
        } else if (u.hostname.includes("twitch.tv")) {
            const channel = u.pathname.replace(/^\//, "");
            embedUrl = `https://player.twitch.tv/?channel=${channel}&parent=${window.location.hostname}`;
        } else if (u.hostname.includes("facebook.com")) {
            embedUrl = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false`;
        }
    } catch { /* keep as-is */ }

    return (
        <div className="ed-card overflow-hidden" data-testid="livestream-embed">
            <p className="label-eyebrow text-accent px-4 pt-4 flex items-center gap-2">
                <span className="live-dot" /> Live
            </p>
            <div className="aspect-video">
                <iframe src={embedUrl} className="w-full h-full border-0" title="Livestream" allow="autoplay; encrypted-media; fullscreen" allowFullScreen />
            </div>
        </div>
    );
}
